import React from 'react'

const ManagePreferredCarrierDialogContext = React.createContext()

export default ManagePreferredCarrierDialogContext
